var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.256,
    height: 56.405,
    viewBox: "0 0 71.256 56.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34356",
    "data-name": "Group 34356",
    transform: "translate(-134.705 -792.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34122",
    "data-name": "Group 34122",
    transform: "translate(-53.344 -129.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34092",
    "data-name": "Group 34092",
    transform: "translate(198.419 928.225)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88282",
    "data-name": "Rectangle 88282",
    width: 31.522,
    height: 49.152,
    rx: 8,
    transform: "translate(0 0)",
    fill: "#eef6ff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33224",
    "data-name": "Group 33224",
    transform: "translate(2.504 4.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33218",
    "data-name": "Group 33218",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27372",
    "data-name": "Path 27372",
    d: "M537.319,695.154H516.41a1.658,1.658,0,0,0-1.608,1.7V709.98a1.365,1.365,0,0,0,1.325,1.4h21.193a1.365,1.365,0,0,0,1.324-1.4V696.556A1.365,1.365,0,0,0,537.319,695.154Z",
    transform: "translate(-514.802 -695.154)",
    fill: "#eef6ff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33223",
    "data-name": "Group 33223",
    transform: "translate(1.903 21.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88283",
    "data-name": "Rectangle 88283",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88284",
    "data-name": "Rectangle 88284",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(8.717 0)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88285",
    "data-name": "Rectangle 88285",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(17.434 0)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88286",
    "data-name": "Rectangle 88286",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(0 7.046)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88287",
    "data-name": "Rectangle 88287",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(8.717 7.046)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88288",
    "data-name": "Rectangle 88288",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(17.434 7.046)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88289",
    "data-name": "Rectangle 88289",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(0 14.091)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88290",
    "data-name": "Rectangle 88290",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(8.717 14.091)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88291",
    "data-name": "Rectangle 88291",
    width: 5.122,
    height: 3.551,
    rx: 1.776,
    transform: "translate(17.434 14.091)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34093",
    "data-name": "Group 34093",
    transform: "translate(189.344 923.367)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88295",
    "data-name": "Rectangle 88295",
    width: 28.997,
    height: 19.784,
    rx: 4,
    transform: "translate(0 5.704) rotate(-11.344)",
    fill: "#eef6ff",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33228",
    "data-name": "Group 33228",
    transform: "translate(19.195 4.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88296",
    "data-name": "Rectangle 88296",
    width: 6.047,
    height: 3.757,
    transform: "translate(0 1.189) rotate(-11.344)",
    fill: "#fff",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34123",
    "data-name": "Group 34123",
    transform: "translate(190 833)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_546",
    "data-name": "Ellipse 546",
    cx: 7.431,
    cy: 7.431,
    r: 7.431,
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33544",
    "data-name": "Group 33544",
    transform: "translate(4.081 4.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27291",
    "data-name": "Path 27291",
    d: "M6319.278,2394.76l2.558,2.281,4.141-5.064",
    transform: "translate(-6319.278 -2391.977)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34124",
    "data-name": "Group 34124",
    transform: "translate(190 814)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_546-2",
    "data-name": "Ellipse 546",
    cx: 7.431,
    cy: 7.431,
    r: 7.431,
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33544-2",
    "data-name": "Group 33544",
    transform: "translate(4.081 4.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27291-2",
    "data-name": "Path 27291",
    d: "M6319.278,2394.76l2.558,2.281,4.141-5.064",
    transform: "translate(-6319.278 -2391.977)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34125",
    "data-name": "Group 34125",
    transform: "translate(190 794)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_546-3",
    "data-name": "Ellipse 546",
    cx: 7.431,
    cy: 7.431,
    r: 7.431,
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33544-3",
    "data-name": "Group 33544",
    transform: "translate(4.081 4.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27291-3",
    "data-name": "Path 27291",
    d: "M6319.278,2394.76l2.558,2.281,4.141-5.064",
    transform: "translate(-6319.278 -2391.977)",
    fill: "none",
    stroke: "#004e9b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step5.212da00c57bbe38eb4c776b7948bc2ac.svg";
export { ForwardRef as ReactComponent };